import styled from 'styled-components'
import {FontWeights} from '../../../../styledComponents/Constants'

export const BoldText = styled.span`
    font-weight: ${FontWeights.Bold};
`